import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import * as NotificationsActions from "src/app/store/notifications/notifications.actions";
import * as HomeActions from 'src/app/store/home/home.actions';
import { Observable, Subscription } from 'rxjs';
import { selectScenariosTabIndex } from 'src/app/store/home/home.selector';
import { selectCurrentSite } from 'src/app/store/site/site.selector';
import { LOCALSTORAGE_CURRENT_SITE_ID } from 'src/app/conf/user';
import { Site } from 'src/app/model/site';
import * as SiteActions from 'src/app/store/site/site.actions';
import * as AnalyticsActions from 'src/app/store/analytics/analytics.actions';

@Component({
	selector: 'app-scenery-tab-group',
	templateUrl: './scenery-tab-group.component.html',
	providers: [],
})

export class SceneryTabGroupComponent implements OnInit, OnDestroy {
	// Observables and subscriptions
	sceneryTabIndex$: Observable<number | undefined>;
	sceneryTabIndexSub: Subscription | undefined;
	site$: Observable<Site | undefined>;
	siteSub: Subscription | undefined;
	currentSiteId: number;

	supportTabIndex: number;

	tabIndex$: Observable<number>;

	// Design
	screenWidth: number;
	MIN_WIDTH_MX7 = 1700;

	constructor(
		private store: Store<AppState>,
	) {
		this.initSelectors();
	}

	ngOnInit() {
		this.store.dispatch(NotificationsActions.setTopbarTitleId({
			stringId: 'SCENARIOS'
		}));
		this.subscribeAll();

		this.catchAnalytics();
	}

	ngOnDestroy(): void {
		this.sceneryTabIndexSub?.unsubscribe();
		this.siteSub?.unsubscribe();
	}

	initSelectors(): void {
		// Store selectors
		this.sceneryTabIndex$ = this.store.select(selectScenariosTabIndex);
		this.site$ = this.store.select(selectCurrentSite);
	}

	subscribeAll(): void {
		this.sceneryTabIndexSub = this.sceneryTabIndex$?.subscribe(
			(supportTabIndex: number) => {
				this.supportTabIndex = supportTabIndex;
			}
		);
		this.siteSub = this.site$?.subscribe((currentSite) => {
			const lsSiteId = localStorage.getItem(LOCALSTORAGE_CURRENT_SITE_ID);
			if (lsSiteId) {
				this.currentSiteId = parseInt(lsSiteId, 10);
			} else {
				this.currentSiteId = currentSite.Id;
			}
			this.store.dispatch(SiteActions.setCurrentSite({ siteId: this.currentSiteId }));
		});
	}

	layoutMarginResponsive(): string {
		return (this.screenWidth >= this.MIN_WIDTH_MX7) ? "mx-7" : "mx-2";
	}

	changeTab(e) {
		this.store.dispatch(HomeActions.selectScenariosTab({ index: e.index }));
		this.catchAnalytics();
	}

	catchAnalytics() {
		switch (this.supportTabIndex) {
			case 1:
				setTimeout(() => {
					this.store.dispatch(AnalyticsActions.eventCustomPageView({ params: { page_title: 'Scenarios | Scenaries' } }));
				}, 1000);
				break;
			case 2:
				setTimeout(() => {
					this.store.dispatch(AnalyticsActions.eventCustomPageView({ params: { page_title: 'Scenarios | Schedules' } }));
				}, 1000);
				break;
			case 3:
				setTimeout(() => {
					this.store.dispatch(AnalyticsActions.eventCustomPageView({ params: { page_title: 'Scenarios | Exclusion calendar' } }));
				}, 1000);
				break;
			default:
				setTimeout(() => {
					this.store.dispatch(AnalyticsActions.eventCustomPageView({ params: { page_title: 'Scenarios | Calendar' } }));
				}, 1000);
				break;
		}
	}
}
